import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserIcon, MenuIcon, XIcon } from "@heroicons/react/outline";
import AuthContext from "./authProvider";
import { Transition } from "@headlessui/react";

import NavBarItem from "./navBarItem";
import NavBarDropdown from "./navBarDropdown";

import auth from "../services/authService";

import "./navBar.css";
const logo = require("../media/logo.png");
const itemStyleName = "text-gray-500 px-3 py-2 rounded-lg text-sm font-medium";

const itemStyleH =
  "text-gray-500 hover:bg-gray-100  px-3 py-2 rounded-lg text-sm font-medium nav-btn z-50";
const itemStyleV =
  "text-gray-500 hover:bg-gray-50  block px-3 py-2 rounded-md text-base font-medium nav-btn z-50";

const NavBar = () => {
  const { auth: authUser, setAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const currentUser = auth.getCurrentUser();
    const accessToken = localStorage.getItem("readsyToken");
    if (!authUser && accessToken) setAuth({ ...currentUser, accessToken });
  }, [authUser]);

  const linkList = [
    // { key: "link_1", href: "/about", label: "About" },
    { key: "link_1", href: "/home", label: "Home" },
    { key: "link_3", href: "/faq", label: "FAQ" },
    // { key: "link_3", href: "/premium", label: "Premium" },
    { key: "link_2", href: "/contact-us", label: "Contact" },
    {
      key: "link_4",
      href: "/extensions",
      label: "Extension",
    },
  ];

  const linkListLogin = [
    { key: "linkUnreg_1", href: "/login", label: "Login" },
    { key: "linkUnreg_2", href: "/register", label: "Register" },
  ];

  const userOptions = [
    {
      key: "user_1",
      text:
        !authUser || !authUser.email
          ? "Unregistered"
          : authUser.email.toLowerCase(),
    },
    { key: "user_3", link: "/user-account", text: "Account" },
    { key: "user_2", link: "/logout", text: "Logout" },
    ,
  ];

  return (
    <>
      <nav className="bg-white shadow dark:bg-gray-800">
        <div className="container px-6 py-4 mx-auto md:flex md:justify-between md:items-center">
          <div className="flex items-center justify-between mx-5 w-full">
            <div className="flex-shrink-0 py-2">
              <a href="/home">
                {" "}
                <img id="navbar-logo" src={logo} alt="Logo" />
              </a>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-center space-x-4">
                {linkList.map((link) => (
                  <NavBarItem {...link} classStyles={itemStyleH} />
                ))}
                {!authUser ? (
                  <></>
                ) : (
                  <NavBarDropdown
                    dropdownStyle="flex items-center justify-center z-50"
                    buttonStyle={itemStyleH}
                    ddOptions={userOptions}
                    label={<UserIcon className="h-5 w-5" />}
                  />
                )}
                {authUser ? (
                  <></>
                ) : (
                  linkListLogin.map((link) => (
                    <NavBarItem {...link} classStyles={itemStyleH} />
                  ))
                )}
              </div>
            </div>
            <div className="mr-2 flex md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                aria-controls="mobile-menu"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                {!isOpen ? (
                  <MenuIcon className="h-6 w-6" />
                ) : (
                  <XIcon className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>

          <Transition
            show={isOpen}
            enter="transition ease-out duration-100 transform"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="transition ease-in duration-75 transform"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            {(ref) => (
              <div className="md:hidden" id="mobile-menu">
                <div ref={ref} className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                  {linkList.map((link) => (
                    <NavBarItem {...link} classStyles={itemStyleV} />
                  ))}
                  {!authUser ? (
                    <></>
                  ) : (
                    <NavBarDropdown
                      dropdownStyle="flex items-center justify-center z-50"
                      buttonStyle={itemStyleH}
                      ddOptions={userOptions}
                      label={<UserIcon className="h-5 w-5" />}
                    />
                  )}
                  {authUser ? (
                    <></>
                  ) : (
                    linkListLogin.map((link) => (
                      <NavBarItem {...link} classStyles={itemStyleV} />
                    ))
                  )}
                </div>
              </div>
            )}
          </Transition>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
